import {CardV2 as PeacockCard} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ICardV2Props} CardProps
 * @property {'interactive' | 'non-interactive' | 'scrollable'} state Card state.
 * @property {string} [maxScrollHeight] Maximum scroll height when state is scrollable.
 * @property {import('@pepsico-ds/ui').CardHeaderProps} cardHeader Card header configuration.
 * @property {import('@pepsico-ds/ui').CardBodyProps} cardBody Card body configuration.
 * @property {'basic' | 'withImage' | 'withBackgroundImage'} type Card presentation type.
 * @property {'mobile' | 'desktop'} [viewport] Viewport size.
 * @property {boolean} [selected] Whether card is selected.
 * @property {boolean} [stickyArea] Whether button hierarchy area is sticky.
 * @property {import('@pepsico-ds/ui').IButtonHierarchyProps} [buttonHierarchy] Button hierarchy props.
 * @property {boolean} [showBookMarkButton] Whether bookmark button is visible.
 * @property {{image: string, orientation: 'horizontal' | 'vertical', width?: string, height?: string, onClickBookMark?: () => void}} [imageProps] Card image props.
 * @property {{image: string, orientation: 'horizontal' | 'vertical', gradient: 'light' | 'dark', nested?: boolean}} [backgroundImageProps] Background image card props.
 * @property {boolean} [naked] Removes container background color.
 * @property {boolean} [nested] Whether card is nested.
 * @property {boolean} [disabled] Whether card is disabled.
 * @property {boolean} [isDraggable] Whether card is draggable.
 * @property {Array<import('@pepsico-ds/ui').CardDataType>} [cardDataList] List-mode card data.
 * @property {Array<import('@pepsico-ds/ui').SortableItem>} [items] Sortable items.
 * @property {number} [animation] Drag animation duration.
 * @property {string} [ghostClass] Class name for drag ghost item.
 * @property {string} [className] Additional CSS classes.
 * @property {(item: import('@pepsico-ds/ui').SortableItem, index: number) => void} [onDragStartHandler] Drag start callback.
 * @property {(item?: import('@pepsico-ds/ui').SortableItem | null, newIndex?: number | null, oldIndex?: number | null, updatedList?: Array<import('@pepsico-ds/ui').SortableItem>) => void} [onDragEndHandler] Drag end callback.
 * @property {string} [sortableCardWidth] Width of sortable cards.
 * @property {string} [sortableCardHeight] Height of sortable cards.
 * @property {number} [scrollSpeed] Auto-scroll speed while dragging.
 * @property {number} [scrollEdgeThreshold] Edge threshold to trigger auto-scroll.
 * @property {boolean} [keyboardAccessible] Enables keyboard sorting interactions.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS CardV2.
 * Supports all Peacock DS card props.
 * @param {CardProps} props
 */
export const Card = props => {
  return <PeacockCard {...props} />
}
